import c from "../common"
export default {
    // Dashboard
    Title: c.EstampPlan.en,
    Create: "Create",
    PointExpiry: "Point Expire",
    EarnPeriodTo: "Earning Period To",
    EarnRate: "spent required per point",

    // Status
    Pending: c.Pending.en,
    OnGoing: c.OnGoing.en,
    ExpiredNCancelled: c.Expired.en + " & " + c.Cancelled.en,
    Cancelled: c.Cancelled.en,
    Expired: c.Expired.en,
    WaitApprove: c.WaitApprove.en,

    // Common
    To: "To",
    NA: c.NA.en,
    Back: c.Back.en,
    Edit: "Edit",
    Previous: c.previous.en,
    Submit: "Submit",
    Complete: c.complete.en,
    Next: c.next.en,
    ConfirmBtn: c.Confirm.en,

    // Detail
    Release: "Voucher Release",
    VoucherExpire: "Voucher Expire",
    EarnStart: "Earning Start",
    EarnEnd: "Earning End",
    EarnRule: "Earning Rule",
    EarnRuleDetail1: "For each $",
    EarnRuleDetail2: " spent in a single purchase, 1 point can be earned",
    EarnRedemption: "Estamp Redemption List",
    Name: "Name",
    RedemptionPeriod: "Redemption Period",
    PaymentMethod: "Payment",
    Quota: "Quota",
    Available: "Left",
    RedeemCost: "Cost",
    EarnRange: "Earning Period",
    Confirm: "Check before submission",
    CreateVoucher: "Create Voucher",
    Add: c.add.en,
    ChooseVoucher: "Select voucher",
    VoucherDetail: "Detail",
    Price: "Price: ",
    QuotaLim: "Quota Limit",
    ReqPoint: "Required Point",
    ReqMoney: "Required Money",
    ChooseFromEvent: "Please choose from existing event",
    CostPoint: "{{point}} point",
    CostMoney: "{{point}} point + ${{money}}",
    Point: "Point",
    PointMoney: "Point + Money",

    // Step
    Detail: "Detail",
    List: "Redemption List",
    Summary: "Summary",

    // Message
    NoVoucher: "No approved voucher",
    Info1: "Quota limit: Voucher Released - Sold amount",
    Info2: "Reserved for Estamp redemption",
    Info3: "Point required for redemption",
    Info4: "Cannot overlap with existing period",
    Info5: "At least 1 event and released voucher need to be created before creating Estamp",
    Info6: "Cannot choose the event that is overlapped with current Estamp plan period",
    Info7: "On Going plan cannot change the following content",
    Info8: "Once submitted the plan will be active",
    Info9: "Point and money are required to redeem this voucher",
    Warning1: "Date overlapped with existing period that this voucher assigned to",
    Warning2: "Quota cannot be 0",
    Warning3: "Required Point cannot be 0",
    Warning4: "Redemption Period cannot be empty",
    Warning5: "Please create event first",
    Warning6: "The total of Pending and On Going Estamp plan cannot exceed 2",
    Warning7: "Change event will clear filled info",
    Warning8: "Please complete the form",
    Warning9: "Please at least add 1 voucher for redemption",
    Warning10: "Warning period cannot overlap",
    Success1: "Success, Estamp plan created",
    Success2: "Success, Estamp plan edited",
}